import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/manga';

interface MangaCardProps {
  manga: Manga;
}

export default function MangaCard({ manga }: MangaCardProps) {
  return (
    <Link
      to={`/article/${manga.id}/1`}
      className="group block rounded-lg bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300 cursor-pointer"
    >
      {/* Cover */}
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={manga.cover}
          alt={`${manga.title}漫画封面`}
          title={`${manga.title} - 在线免费阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          width="600"
          height="800"
        />
        {/* Status Badge */}
        <span
          className={`absolute top-2 right-2 px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
            manga.status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}
        >
          {manga.status}
        </span>
        {/* Rating */}
        <div className="absolute bottom-2 left-2 px-2 py-1 rounded-full bg-background-950/70 text-accent-500 text-xs font-medium flex items-center gap-1">
          <i className="ri-star-fill text-[10px]"></i>
          {manga.rating}
        </div>
      </div>

      {/* Info */}
      <div className="p-3">
        <h3 className="font-heading text-sm text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
          {manga.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{manga.author}</p>
        <div className="flex items-center justify-between mt-2 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {manga.views >= 10000 ? `${(manga.views / 10000).toFixed(0)}万` : manga.views}
          </span>
          <span className="whitespace-nowrap">
            {manga.chapters}话
          </span>
        </div>
      </div>
    </Link>
  );
}